import { MDBBtn, MDBIcon, MDBModalFooter } from 'mdb-react-ui-kit';
import React, { forwardRef, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { getMisc, purchaseStorage } from '../../../apiclients/streamsapi_bridge';
import { Tooltip } from 'react-tooltip';

const StoragePurchased = forwardRef((props, ref) => {
    const { t, i18n } = useTranslation();
    const [storageFlag, setstorageFlag] = useState(false);
    const [displayMessage, setdisplayMessage] = useState("");
    const [storageList, setStorageList] = useState([]);
    const [defaultValues, setdefaultValues] = useState({})
    const [billingGroups, setBillingGroups] = useState([]);
    const { register, handleSubmit, formState: { errors, isDirty }, setValue, getValues, watch, reset, setError, clearErrors } = useForm({
        defaultValues: {
            storage_type: 1,
            quantity: "",
            billing_group_id: -1

        }
    })

    async function fetchLocations() {
        console.log(sessionStorage.getItem("admin_session"));
        console.log("fid ::::: " + props.storageObj.fid);
        const response = await getMisc(
            JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            { misc: ["purchase_addon"], fid: parseInt(props.storageObj.fid) }
        );
        if (!response.json) {
            const message = `An error has occured: ${response.statusText}`;
            return;
        }
        const tdata = await response.json();
        if (!tdata) {
            window.alert(`info with id  not found`);
        }
        console.log("purchase details :::::: " + JSON.stringify(tdata));

        // const transformedLocationsList = (locationList || []).map(location => ({ text: location.location_name, value: locations.location_id }));
        const billGrps = tdata?.misc?.purchase_addon?.billing_groups ?? [];
        setBillingGroups(billGrps);
        let defaultBillingGrp = billGrps.find(bGrp => bGrp.groupname == "Default_Billing_Group")
        // isStorage = tdata?.misc?.purchase_addon?.storage_type && tdata?.misc?.purchase_addon?.storage_type.length > 0 ? true : false;
        setstorageFlag(tdata?.misc?.purchase_addon?.storage_type && tdata?.misc?.purchase_addon?.storage_type.length > 0 ? true : false);
        const storageDropDown = tdata?.misc?.purchase_addon?.storage_type ?? [];
        setdisplayMessage(tdata?.misc?.purchase_addon?.display_message ?? "");
        if (storageDropDown && storageDropDown.length > 0) {

            // const convertedArray = storageDropDown.map(item => {
            //     const key = Object.keys(item)[0]; // Extracting the key
            //     const value = item[key]; // Extracting the value
            //     return { text: value, value: parseInt(key) }; // Constructing the desired object
            // });
            // alert(JSON.stringify(convertedArray));

            setStorageList(storageDropDown);
        }


        setdefaultValues({
            storage_type: 1,
            quantity: "",
            billing_group_id: -1,
        });
    }

    useEffect(() => {
        if (Object.keys(defaultValues).length !== 0) reset(defaultValues);
    }, [defaultValues]);


    useEffect(() => {
        if (props.storageObj && Object.keys(props.storageObj).length > 0) {
            fetchLocations();
        }
    }, [props.storageObj]);

    const onSubmit = async (data) => {
        try {
            let flag = 0;
            if (!data.quantity || data.quantity.trim() == "") {
                setError("quantity", { message: "Quantity is required" });
                flag = 1;
            }
            if (data.billing_group_id == -1) {
                setError("billing_group_id", { message: "Please select a billing group" });
                flag = 1;
            }
            if (flag == 1) {
                return;
            }
            let update = {
                reqid: 67,
                fid: parseInt(props.storageObj.fid),
                siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                billing_group_id: parseInt(data.billing_group_id),
                quantity: parseInt(data.quantity),
            }
            if (storageFlag) {
                update.storage_type = parseInt(data.storage_type);
            }

            console.log("Request JSON for purchase ::::: " + JSON.stringify(update));
            let saverep = await purchaseStorage(update);
            console.log(saverep);
            let saverepeMsg = await saverep.json();
            console.log("response autopurchase ::::: " + JSON.stringify(saverepeMsg))
            //alert(saverepeMsg.status);
            if (saverepeMsg.status && saverepeMsg.status == "success") {
                props.setSuccessMessage(saverepeMsg.message);
                props.setrerender(true);
                props.onClose();




            } else {
                if (saverepeMsg.message?.errors) {
                    saverepeMsg.message.errors.forEach((err) => {

                        setError(err.param_name, {
                            type: "server",
                            message: err.message,
                        });

                    });
                }


            }

        } catch (error) {

        }
    }

    return (
        <>
            <div className='pb-5'>
                {storageFlag && (
                    <div className="d-flex mt-3 ">
                        <div className="fw-600  w_100px mt-2">Storage: </div>
                        <div className="d-flex w-200px flex-column">
                            <div className="form-outline w-200px">
                                <select className='form-select w-200px'
                                    {...register("storage_type")}
                                //value={watch("storage_type")}
                                // onChange={(value) => setValue("storage_type", value, { shouldDirty: true })}
                                >
                                    {storageList && storageList.map((item, index) => {
                                        const key = Object.keys(item)[0]; // Extracting the key
                                        const value = item[key]; // Extracting the value
                                        return (
                                            <option key={index} value={key}>
                                                {value}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        </div>
                    </div>
                )}
                <div className="d-flex mt-3">
                    <div className="fw-600  w_100px mt-2">Quantity: </div>
                    <div className="d-flex  w-200px flex-column">
                        <div className="d-flex align-items-center">
                            <div className='form-outline w-200px'>
                                <input className='form-control w-200px'  {...register("quantity"
                                )} />
                            </div>
                            {/* <MDBInput size="sm" id='form1' type='text' {...register("quantity", {
                                required: "quantity is required"
                            })} /> */}
                            <div className="d-flex ms-1"> X{storageList.length ? storageList[watch("storage_type") - 1][watch("storage_type")] : "1GB"}</div>
                        </div>
                        {errors.quantity && (
                            <span className="text-danger">{errors.quantity.message}</span>
                        )}
                        <p className="m-0 text-small"><strong>Note: </strong>{displayMessage}</p>
                    </div>
                </div>

                <div className="d-flex mt-3 ">
                    <div className="fw-600  w_100px mt-2">Billing Groups: </div>
                    <div className="d-flex w-200px ">
                        <div className="d-flex align-items-center">
                            <div className="d-flex flex-column position-relative w-200px">
                                <select className='form-select '
                                    {...register("billing_group_id", { required: "Billing group is required" })}
                                    onChange={(e) => {
                                        e.preventDefault();
                                        if (e.target.value == -1) {
                                            setError("billing_group_id", { message: "select the billing group" })
                                            setValue("billing_group_id", e.target.value, { shouldDirty: true });
                                        } else {
                                            clearErrors("billing_group_id");
                                            setValue("billing_group_id", e.target.value, { shouldDirty: true });
                                        }
                                    }}
                                >
                                    <option key={-1} value={-1}>
                                        --Select the Billing group--
                                    </option>
                                    {billingGroups &&
                                        billingGroups.map((item) => (
                                            <>

                                                <option key={item.groupid} value={item.groupid}>
                                                    {item.groupname}
                                                </option>
                                            </>
                                        ))}
                                </select>
                                {errors.billing_group_id && (
                                    <span className="text-danger">{errors.billing_group_id.message}</span>
                                )}
                                {/* <MDBSelect
                                    className=""
                                    data={[
                                        { text: 'Inherit From Location', value: 1 },
                                    ]}
                                    value={1}
                                /> */}

                                <a className="text-primary mb-3 storageManager">
                                    <MDBIcon far icon="question-circle" className="ms-2" />
                                </a>
                                <p className="m-0 text-small w-300px"><strong>Note: </strong>*  Indicates that the Subtotal Group is already added to one or more Invoice Group</p>


                            </div>



                        </div>
                    </div>
                </div>

                <div style={{ display: "none" }}>
                    <button ref={ref} onClick={(e) => { e.preventDefault(); handleSubmit(onSubmit)() }}>
                        {t("Save")}</button>
                </div>

                {/* <MDBModalFooter>
                    <MDBBtn color='secondary' onClick={props.onClose}>
                        Cancel
                    </MDBBtn>
                    <MDBBtn onClick={(e) => {
                        e.preventDefault();
                        handleSubmit(onSubmit)();
                    }}>Save</MDBBtn>
                </MDBModalFooter> */}

            </div>


            <Tooltip
                anchorSelect=".storageManager"
                place="top"
                className="exampleTooltipLight"
                style={{ maxWidth: "300px", width: "300px" }}
            >
                <div className="w-100">
                    <p className="text-start text-small mb-3">Billing Group can be an invoice group(indicated by "I") or a subtotal group(indicated by "S"). </p>
                    <p className="text-start text-small">The billable item(s) must be included in at least one invoice group. If a billable item is included in multiple invoice/subtotal groups, the charges for the billable item(s) is/are divided among the respective invoice/subtotal groups.</p>
                </div>


            </Tooltip>



        </>
    )
});

export default StoragePurchased;
